// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".f84966c5490b4cc52dba664ec2363a873cef4e23.chunk.js";
};